import { render, staticRenderFns } from "./CertificatePreview.vue?vue&type=template&id=09133b04&scoped=true"
import script from "./CertificatePreview.vue?vue&type=script&lang=js"
export * from "./CertificatePreview.vue?vue&type=script&lang=js"
import style0 from "./CertificatePreview.vue?vue&type=style&index=0&id=09133b04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09133b04",
  null
  
)

export default component.exports